<template>
  <div>
    <CRow>
      <CCol>
        <CCard class="bg-style2">
          <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
            <span class="font-weight-bold h6"> <CIcon name="cil-badge"/> {{ caption }} </span>
            <div class="card-header-actions">
              <CButton
                size="sm"
                color="light"
                variant="outline"
                class="export-icon-button"
                :disabled="loading || !item.length"
                title="Export Excel"
                aria-label="Export Excel"
                v-c-tooltip.hover.click="'Export Excel'"
                @click="exportAll"
              >
                <CIcon name="cil-cloud-download"/>
              </CButton>
            </div>
          </CCardHeader>
          <CCardBody>


            <CRow>
              <CCol>
                <CDataTable
                    :table-filter="{label:''}"
                    :fields="fields"
                    :items="item"
                    :items-per-page="small ? 50 : 20"
                    :dark="dark"
                    :loading="loading"
                    pagination
                    :items-per-page-select="pages"
                    sorter
                >

                  <template #index="{item,index}">
                    <td class="text-center" @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
                  </template>


                  <template #total="{item,index}">
                    <td class="text-center" @click="toggleDetails(item, index)">
                      {{ item.total }}
                    </td>
                  </template>


                  <template #value="{item,index}">
                    <td class="text-center" @click="toggleDetails(item, index)">
                      {{ item.value }} {{ formatPercent(item.value, item.total) }}
                    </td>
                  </template>

                  <template #pending="{item,index}">
                    <td class="text-center" @click="toggleDetails(item, index)">
                      {{ item.pending }} {{ formatPercent(item.pending, item.value) }}
                    </td>
                  </template>

                  <template #completed="{item,index}">
                    <td class="text-center" @click="toggleDetails(item, index)">
                      {{ item.completed }} {{ formatPercent(item.completed, item.value) }}
                    </td>
                  </template>

                  <template #progress="{item,index}">
                    <td class="text-center" @click="toggleDetails(item, index)">
                      {{ item.progress }} {{ formatPercent(item.progress, item.value) }}
                    </td>
                  </template>




<!--                  <template #complete="{item,index}">-->
<!--                    <td class="text-center" @click="toggleDetails(item, index)">-->
<!--&lt;!&ndash;                      {{ item.complete }} {{ '( ' + (((item.complete) / item.total) * 100).toFixed(2) + '% )' }}&ndash;&gt;-->
<!--                    </td>-->
<!--                  </template>-->

<!--                  <template #total="{item,index}">-->
<!--                    <td class="text-center" @click="toggleDetails(item, index)">-->
<!--                      {{ ((item.isGap / item.total) * 100).toFixed(2) }}-->
<!--                    </td>-->
<!--                  </template>-->

<!--                  <template #isMeets="{item,index}">-->
<!--                    <td class="text-center" @click="toggleDetails(item, index)">-->
<!--                      {{ item.isMeets }} {{ '( ' + (((item.isMeets) / item.total) * 100).toFixed(2) + '% )' }}-->
<!--                    </td>-->
<!--                  </template>-->

<!--                  <template #isExceeding="{item,index}">-->
<!--                    <td class="text-center" @click="toggleDetails(item, index)">-->
<!--                      {{ item.isExceeding }} {{ '( ' + (((item.isExceeding) / item.total) * 100).toFixed(2) + '% )' }}-->
<!--                    </td>-->
<!--                  </template>-->

                  <template #action="{item,index}">
                    <td style="width: 140px">
                      <CRow>
                        <CCol class="text-center">
                          <CButton class="mr-1" v-c-tooltip.hover.click="$t('reports.member')" size="sm" color="info" shape="pill" variant="outline" @click="toggleDetails(item,index)"  >
                            <CIcon name="cil-description"/>
                          </CButton>
                          <CButton v-c-tooltip.hover.click="'Info'" size="sm" color="info" shape="pill" variant="outline" @click="toggleDetailsChart(item,index)"  >
                            <CIcon name="cil-list-rich"/>
                          </CButton>
                        </CCol>
                      </CRow>
                    </td>
                  </template>

                  <template #details="{item,index}">
                    <CCollapse :show="Boolean(item._toggledC)" :duration="collapseDuration">
                      <CCard class="bg-style mb-4 border-dark">
                        <CCardHeader class="bg-gradient-dark text-white" >
                          <span class="font-weight-bold h6">
                            <CIcon name="cil-people" class="mr-2"/>
                            <label class="font-weight-bold"> {{ $t('reports.member') }} </label>
                          </span>
                        </CCardHeader>
                        <CCardBody>
                          <Method_IDP1 :item="objse" :loading="loading"/>
                        </CCardBody>
                      </CCard>
                    </CCollapse>

                    <CCollapse :show="Boolean(item._toggled)" :duration="collapseDuration">

                      <CCard class="bg-style mb-4 border-dark">
                        <CCardHeader class="bg-gradient-dark text-white" >
                          <span class="font-weight-bold h6">
                            <CIcon name="cil-people" class="mr-2"/>
                            <label class="font-weight-bold"> {{ $t('reports.member') }} </label>
                          </span>
                        </CCardHeader>
                        <CCardBody>
                          <CDataTable
                              :table-filter="{label:''}"
                              :fields="subfields"
                              :items="item.history"
                              :items-per-page="small ? 50 : 20"
                              :dark="dark"
                              :loading="loading"
                              pagination
                              :items-per-page-select="pages"
                              sorter
                          >

                            <template #index="{item,index}">
                              <td class="text-center" @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
                            </template>
                            <template #levels="{item,index}">
                              <td class="text-center" @click="toggleDetails(item, index)"> {{ item.levels  }}</td>
                            </template>
                          </CDataTable>
                        </CCardBody>
                      </CCard>

                    </CCollapse>
                  </template>
                </CDataTable>
              </CCol>
              <CCol col="12">
                <CDropdownDivider/>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import Method_IDP1 from "@/projects/views/E-Performances/Reports/components/Methods1.vue";
import * as XLSX from "xlsx";

export default {
  name: "ReportCompetencyIDP",
  components: {Method_IDP1},
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Banks'
    },

    item: {
      type: Array,
      default() {
        return []
      }
    },
    year: {
      type: Number,
      default: null
    },
    fields: {
      type: Array,
      default() {
        return [
          {key: "index", label: "#", _style: 'width:50px; text-align: center'},
          {key: "title", label: "ประเภทสมรรถนะ"},
          {key: "total", label: "Total", _style: 'width:150px; text-align: center'},
          {key: "value", label: "Count", _style: 'width:150px; text-align: center'},
          {key: "pending", label: "Pending", _style: 'width:150px; text-align: center'},
          {key: "progress", label: "In Progress", _style: 'width:150px; text-align: center'},
          {key: "completed", label: "Complete", _style: 'width:100px; text-align: center'},
          // {key: "isMeets", label: "Meets Expectations ", _style: 'width:150px; text-align: center'},
          // {key: "isWithin", label: "Within Expectations", _style: 'width:150px; text-align: center'},
          // {key: "isExceeding", label: "Exceeds Expectations", _style: 'width:150px; text-align: center'},
          {key:"action", label: "#", _style: 'width:20px; text-align: center'}
        ]
      }
    },

    subfields: {
      type: Array,
      default() {
        return [
          {key: "index", label: "#", _style: 'width:50px; text-align: center'},
          {key:"accounts", label:"Name"},
          {key:"levels", label:"Level", _style: 'width:50px; text-align: center'},
          {key:"assessor", label:"Assessor"},
          {key: "state", label:"Status"}
          // {key: "isWithin", label: "Within Expectations", _style: 'width:150px; text-align: center'},
          // {key: "isExceeding", label: "Exceeds Expectations", _style: 'width:150px; text-align: center'},
          // {key:"action", label: "#", _style: 'width:20px; text-align: center'}
        ]
      }
    },


    type: {
      type: String,
      default: 'cil-user'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,

    pages: {
      type: Object,
      default() {
        return {
          values: [10, 20, 50, 100]
        }
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
  },

  mounted() {

  },

  created() {},
  beforeDestroy() {

  },
  data() {
    return {
      collapseDuration: 0,
      objse: [],
    }
  },
  methods:{
    toggleDetails (item,index) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})

      // this.$emit('info',item)
    },

    toggleDetailsChart(item,index) {
      const grouped = {};

      (Array.isArray(item.history) ? item.history : []).forEach((history) => {
        const title = history && history.state ? history.state : 'Unknown';
        grouped[title] = (grouped[title] || 0) + 1;
      });

      this.objse = Object.keys(grouped).map((title) => ({
        title,
        value: grouped[title]
      })).sort((a, b) => b.value - a.value);

      item._toggledC = !item._toggledC
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})
    },

    formatPercent(value, total) {
      const numerator = Number(value || 0);
      const denominator = Number(total || 0);

      if (!denominator) {
        return '( 0.00% )';
      }

      return `( ${((numerator / denominator) * 100).toFixed(2)}% )`;
    },
    buildSummaryRows() {
      return this.item.map((entry, index) => ({
        index: index + 1,
        competencyType: entry.title,
        total: entry.total,
        count: entry.value,
        pending: entry.pending,
        inProgress: entry.progress,
        completed: entry.completed
      }));
    },
    buildDetailRows() {
      return this.item.flatMap((entry) =>
        (entry.history || []).map((history, index) => ({
          competencyType: entry.title,
          order: index + 1,
          name: history.accounts || "-",
          level: history.levels || "-",
          assessor: history.assessor || "-",
          status: history.state || "-"
        }))
      );
    },
    exportAll() {
      const workbook = XLSX.utils.book_new();
      const summarySheet = XLSX.utils.json_to_sheet(this.buildSummaryRows());
      const detailSheet = XLSX.utils.json_to_sheet(this.buildDetailRows());

      XLSX.utils.book_append_sheet(workbook, summarySheet, "CompetencySummary");
      XLSX.utils.book_append_sheet(workbook, detailSheet, "CompetencyDetails");
      XLSX.writeFile(workbook, `idp-competency-summary-${this.year || "report"}.xlsx`);
    }
  }
}
</script>

<style scoped>
.export-icon-button {
  align-items: center;
  background: #2f9bff;
  border-color: #2f9bff;
  border-radius: 50%;
  box-shadow: 0 8px 18px rgba(47, 155, 255, 0.28);
  color: #fff;
  display: inline-flex;
  height: 36px;
  justify-content: center;
  padding: 0;
  width: 36px;
}

.export-icon-button:hover,
.export-icon-button:focus {
  background: #168af0;
  border-color: #168af0;
  color: #fff;
}

.export-icon-button:disabled {
  background: #8ecaff;
  border-color: #8ecaff;
  box-shadow: none;
  color: rgba(255, 255, 255, 0.78);
}
</style>
